module.exports = __webpack_public_path__ + "img/p2-green.b17e671d.png";